import * as React from "preact";
import { render } from "preact";

import App from "./App";

function init() {
  const el = document.getElementById("pdf-form-app");
  if (el) {
    const { fileUploadLimit, apiKey, apiSubmitUrl, imageParameters, apiImageUploadUrl, stringParameters, documentKey } =
      el.dataset;
    render(
      <App
        fileUploadLimit={Number(fileUploadLimit)}
        apiKey={apiKey}
        apiSubmitUrl={apiSubmitUrl}
        apiImageUploadUrl={apiImageUploadUrl}
        stringParameters={stringParameters}
        imageParameters={imageParameters}
        documentKey={documentKey}
      />,
      el
    );
  }
}

export default { init };
